import FrontendAPIErrorManager from './FrontendApiErrorManager';
export default FrontendAPIErrorManager;
